import Yup from 'utils/validation';
import { Fields } from '../types/Form';

// Trimmed because the API resolves an analysis by an exact externalId match, so
// a pasted trailing space makes every inbound candidate unresolvable (PAD-6239).
export const externalIdSchema = Yup.object({
  externalId: Yup.string().trim().required('Enter an ID')
});

export const externalIdSchemaOptional = Yup.object({
  externalId: Yup.string().trim().optional()
});

export type ExternalIdFormData = Yup.InferType<typeof externalIdSchema>;

export type ExternalIdFormDataOptional = Yup.InferType<
  typeof externalIdSchemaOptional
>;

export const externalIdFields: Fields<
  ExternalIdFormData | ExternalIdFormDataOptional
> = {
  externalId: {
    label: 'External ID',
    subLabel: 'Identifies your campaign in Popp’s API.',
    type: 'text'
  }
};
